/* taiga-v2-look.js — look builder: per-piece buttons stage items in a local look
   list (with remove), the main button pushes the list to the cart and goes to checkout */
(function(){
  function eur(cents){ return '€' + (Number(cents)/100).toFixed(2).replace('.',','); }
  function rateFor(n){ return n>=4?10:n===3?8:n===2?5:0; }
  function fmtMoney(root, cents){
    var mf = root && root.dataset && root.dataset.moneyFormat;
    // Shopify.formatMoney expects string like "{{amount}} €" etc — use if available
    if(window.Shopify && typeof Shopify.formatMoney === 'function' && mf){
      try{ return Shopify.formatMoney(cents, mf); }catch(e){ /* fallback */ }
    }
    // Fallback: try Intl with currency from root
    var cur = root && root.dataset && root.dataset.currency;
    if(cur){
      try{
        return new Intl.NumberFormat(undefined, {style:'currency', currency:cur, minimumFractionDigits:2}).format(Number(cents)/100);
      }catch(e){ /* fallback to eur */ }
    }
    return eur(cents);
  }

  function init(root){
    if(!root || root.dataset.bwReady==='1') return;
    root.dataset.bwReady='1';

    var piecesWrap = root.querySelector('[data-bw-pieces]');
    var cnt = root.querySelector('[data-bw-cnt]');
    var itemsLabelEl = root.querySelector('[data-bw-items-label]');
    var subEl = root.querySelector('[data-bw-sub]');
    var saveRow = root.querySelector('[data-bw-save-row]');
    var rateEl = root.querySelector('[data-bw-rate]');
    var saveEl = root.querySelector('[data-bw-save]');
    var totEl = root.querySelector('[data-bw-tot]');
    var wasEl = root.querySelector('[data-bw-was]');
    var addBtn = root.querySelector('[data-bw-add]');
    var nudge = root.querySelector('[data-bw-nudge]');
    var added = root.querySelector('[data-bw-added]');
    var listEl = root.querySelector('[data-bw-look-list]');
    var tierEls = [].slice.call(root.querySelectorAll('[data-bw-tier]'));

    var i18nEl = root.querySelector('script[data-bw-i18n]');
    var i18n = {};
    if(i18nEl){
      try{ i18n = JSON.parse(i18nEl.textContent); }catch(e){}
    }
    var loc = i18n.locale || 'sr';

    if(!piecesWrap) return;

    // Build state from DOM JSON
    var cards = [].slice.call(piecesWrap.querySelectorAll('.piece'));
    var state = {}; // id -> {sel, size, qty, variantId, price, title, options, variants}
    var productData = {}; // id -> {title, price, options:[], variants:[], image}
    var lookItems = []; // staged look lines: {variantId, productId, title, options, qty, price, image}

    cards.forEach(function(card){
      var pid = card.getAttribute('data-bw-id');
      var dataEl = card.querySelector('script[data-bw-data]');
      if(!dataEl) return;
      var data;
      try{ data = JSON.parse(dataEl.textContent); }catch(e){ return; }
      productData[pid] = data;
      state[pid] = {
        sel: card.classList.contains('sel'),
        size: null,
        qty: 1,
        variantId: null,
        price: data.price,
        title: data.title,
        options: data.options || [],
        variants: data.variants || []
      };

      // If single-variant product, pre-resolve variantId
      var isSingle = data.options.length===0 || (data.options.length===1 && (data.options[0]==='Title' || data.variants.length===1));
      if(isSingle && data.variants[0]){
        state[pid].variantId = data.variants[0].id;
        state[pid].price = data.variants[0].price;
        state[pid].size = '_single';
      }
    });

    function cardById(pid){
      return piecesWrap.querySelector('[data-bw-id="'+pid+'"]');
    }

    function findVariant(pid){
      var st = state[pid], d = productData[pid];
      if(!d) return null;
      if(d.options.length===0 || (d.options.length===1 && d.options[0]==='Title')) return d.variants[0] || null;
      var card = cardById(pid);
      if(!card) return null;
      var chosen = {};
      card.querySelectorAll('.sw.on').forEach(function(sw){
        var opt = sw.getAttribute('data-opt');
        var val = sw.getAttribute('data-val');
        chosen[opt]=val;
      });
      card.querySelectorAll('.sz.on').forEach(function(sz){
        var opt = sz.getAttribute('data-opt') || 'Size';
        // fallback: if option name unknown, assume last option
        if(d.options.length===1) chosen[d.options[0]] = sz.getAttribute('data-val');
        else chosen[opt]=sz.getAttribute('data-val');
      });
      // Also handle generic chips (non colour/size)
      card.querySelectorAll('.mm-chip.is-sel').forEach(function(chip){
        chosen[chip.getAttribute('data-opt')] = chip.getAttribute('data-val');
      });
      // Match
      for(var i=0;i<d.variants.length;i++){
        var v = d.variants[i];
        var ok=true;
        for(var oi=0; oi<d.options.length; oi++){
          var oname = d.options[oi];
          var want = chosen[oname];
          // if no chip selected for this option, consider incomplete
          if(want==null) { ok=false; break; }
          if(v.options[oi] !== want) { ok=false; break; }
        }
        if(ok) return v;
      }
      return null;
    }

    function isComplete(pid){
      var st = state[pid], d = productData[pid];
      if(!st.sel) return false;
      if(!d) return false;
      // single variant always complete when sel
      if(d.options.length===0 || (d.options.length===1 && d.options[0]==='Title')) return true;
      // require each option selected, and variant exists & available
      for(var i=0;i<d.options.length;i++){
        var oname=d.options[i];
        var card=cardById(pid);
        var has=false;
        card.querySelectorAll('.sw.on, .sz.on, .mm-chip.is-sel').forEach(function(el){
          if(el.getAttribute('data-opt')===oname) has=true;
        });
        // legacy: size stored
        if(oname.toLowerCase().indexOf('size')!==-1 && st.size) has=true;
        if(!has) return false;
      }
      var v=findVariant(pid);
      return v && v.available !== false;
    }

    function updateVariantPrice(pid){
      var v=findVariant(pid);
      if(v){
        state[pid].variantId=v.id;
        state[pid].price=v.price;
        var card=cardById(pid);
        var priceEl=card.querySelector('.pr');
        if(priceEl) priceEl.textContent=fmtMoney(root, v.price);
      }
    }

    function itemByVariant(vid){
      for(var i=0;i<lookItems.length;i++){
        if(String(lookItems[i].variantId)===String(vid)) return lookItems[i];
      }
      return null;
    }

    function addToLook(pid, v, qty){
      var found=itemByVariant(v.id);
      if(found){
        found.qty=Math.min(99, found.qty+qty);
      } else {
        var d=productData[pid] || {};
        lookItems.push({
          variantId: v.id,
          productId: pid,
          title: d.title || '',
          options: (v.options||[]).join(', '),
          qty: qty,
          price: v.price,
          image: d.image || ''
        });
      }
      return itemByVariant(v.id);
    }

    function formatItem(it){
      if(!it) return '';
      return it.title + (it.options ? ' ('+it.options+')' : '') + ' ×' + it.qty;
    }

    var addedTimer=null;
    function showAdded(text){
      if(!added) return;
      added.style.display='block';
      added.textContent=text;
      if(addedTimer) clearTimeout(addedTimer);
      addedTimer=setTimeout(function(){ added.style.display='none'; }, 3000);
    }

    // Wire up controls
    cards.forEach(function(card){
      var pid=card.getAttribute('data-bw-id');
      var st=state[pid], d=productData[pid];
      if(!d) return;
      // toggle select / expand
      var ptop=card.querySelector('.ptop');
      if(ptop){
        ptop.addEventListener('click', function(){
          st.sel=!st.sel;
          card.classList.toggle('sel', st.sel);
          // if deselected, clear warn
          if(!st.sel) card.classList.remove('warn');
          render();
        });
      }
      // colours
      card.querySelectorAll('.sw').forEach(function(sw){
        sw.addEventListener('click', function(e){
          e.stopPropagation();
          if(sw.classList.contains('oos')) return;
          card.querySelectorAll('.sw').forEach(function(x){x.classList.remove('on');});
          sw.classList.add('on');
          updateVariantPrice(pid);
          card.classList.remove('warn');
          render();
        });
      });
      // sizes
      card.querySelectorAll('.sz').forEach(function(sz){
        if(sz.classList.contains('oos')) return;
        sz.addEventListener('click', function(e){
          e.stopPropagation();
          card.querySelectorAll('.sz').forEach(function(x){x.classList.remove('on');});
          sz.classList.add('on');
          st.size=sz.getAttribute('data-val');
          updateVariantPrice(pid);
          card.classList.remove('warn');
          render();
        });
      });
      // generic chips (for non size/colour options)
      card.querySelectorAll('[data-bw-chip]').forEach(function(chip){
        if(chip.classList.contains('oos')||chip.disabled) return;
        chip.addEventListener('click', function(e){
          e.stopPropagation();
          var grp=chip.closest('[data-bw-optgrp]');
          grp.querySelectorAll('[data-bw-chip]').forEach(function(c){c.classList.remove('is-sel');});
          chip.classList.add('is-sel');
          grp.classList.remove('needs');
          updateVariantPrice(pid);
          card.classList.remove('warn');
          render();
        });
      });
      // qty
      card.querySelectorAll('[data-bw-qty]').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.stopPropagation();
          var delta=parseInt(btn.getAttribute('data-bw-qty'),10);
          st.qty=Math.max(1, Math.min(99, st.qty+delta));
          var qv=card.querySelector('[data-bw-qv]');
          if(qv) qv.textContent=st.qty;
          render();
        });
      });
      // per-piece add -> staged look list (no cart request)
      var singleBtn=card.querySelector('[data-bw-single]');
      if(singleBtn){
        singleBtn.addEventListener('click', function(e){
          e.stopPropagation();
          if(!st.sel){
            st.sel=true; card.classList.add('sel');
          }
          if(!isComplete(pid)){
            card.classList.add('warn');
            render();
            return;
          }
          var v=findVariant(pid);
          if(!v || v.available===false){
            card.classList.add('warn');
            render();
            return;
          }
          var item=addToLook(pid, v, st.qty);
          card.classList.remove('warn');
          // reset quantity after adding
          st.qty=1;
          var qv=card.querySelector('[data-bw-qv]');
          if(qv) qv.textContent=1;
          singleBtn.disabled=true;
          var prev=singleBtn.textContent;
          singleBtn.textContent=i18n.added || 'Added ✓';
          setTimeout(function(){ singleBtn.textContent=prev; singleBtn.disabled=false; }, 1400);
          showAdded((i18n.addedToLook || '✓ Added to your look')+': '+formatItem(item));
          render();
        });
      }
    });

    // remove staged items
    if(listEl){
      listEl.addEventListener('click', function(e){
        var btn = e.target && e.target.closest ? e.target.closest('[data-bw-remove]') : null;
        if(!btn) return;
        var vid=btn.getAttribute('data-bw-remove');
        for(var i=0;i<lookItems.length;i++){
          if(String(lookItems[i].variantId)===String(vid)){
            lookItems.splice(i,1);
            break;
          }
        }
        render();
      });
    }

    function renderList(){
      if(!listEl) return;
      listEl.innerHTML='';
      if(!lookItems.length){
        var empty=document.createElement('div');
        empty.className='ll-empty';
        empty.textContent=i18n.lookEmpty || '';
        listEl.appendChild(empty);
        return;
      }
      lookItems.forEach(function(it){
        var row=document.createElement('div');
        row.className='ll-item';

        var thumb=document.createElement('div');
        thumb.className='ll-thumb';
        if(it.image){
          var img=document.createElement('img');
          img.src=it.image;
          img.alt=it.title || '';
          img.loading='lazy';
          thumb.appendChild(img);
        }
        row.appendChild(thumb);

        var meta=document.createElement('div');
        meta.className='ll-meta';
        var nm=document.createElement('div');
        nm.className='ll-nm';
        nm.textContent=it.title;
        meta.appendChild(nm);
        if(it.options){
          var op=document.createElement('div');
          op.className='ll-op';
          op.textContent=it.options;
          meta.appendChild(op);
        }
        var line=document.createElement('div');
        line.className='ll-line';
        line.textContent=it.qty+' × '+fmtMoney(root, it.price);
        meta.appendChild(line);
        row.appendChild(meta);

        var rm=document.createElement('button');
        rm.type='button';
        rm.className='ll-rm';
        rm.setAttribute('data-bw-remove', it.variantId);
        rm.setAttribute('aria-label', (i18n.remove || 'Remove')+': '+it.title);
        rm.innerHTML='&times;';
        row.appendChild(rm);

        listEl.appendChild(row);
      });
    }

    function render(){
      var units=0, subtotal=0;
      lookItems.forEach(function(it){
        units += it.qty;
        subtotal += it.price * it.qty;
      });
      var r=rateFor(units), saving=Math.round(subtotal*r/100), total=subtotal-saving;

      if(cnt) cnt.textContent=units;
      if(itemsLabelEl){
        if(loc==='sr'){
          itemsLabelEl.textContent = (units===1 ? 'komad u vašem izgledu' : 'komada u vašem izgledu');
        } else if(loc==='de'){
          itemsLabelEl.textContent = 'Artikel in Ihrem Look';
        } else {
          itemsLabelEl.textContent = (units===1 ? 'item in your look' : 'items in your look');
        }
      }

      renderList();

      cards.forEach(function(card){
        var pid=card.getAttribute('data-bw-id');
        var inLook=lookItems.some(function(it){ return it.productId===pid; });
        card.classList.toggle('in', inLook);
      });

      if(subEl) subEl.textContent=fmtMoney(root, subtotal);
      if(r>0){
        if(saveRow) saveRow.style.display='flex';
        if(rateEl) rateEl.textContent=r;
        if(saveEl) saveEl.textContent='–'+fmtMoney(root, saving);
        if(wasEl){ wasEl.style.display='inline'; wasEl.textContent=fmtMoney(root, subtotal); }
      } else {
        if(saveRow) saveRow.style.display='none';
        if(wasEl) wasEl.style.display='none';
      }
      if(totEl) totEl.textContent=fmtMoney(root, total);
      tierEls.forEach(function(tp){ tp.classList.toggle('active', units >= parseInt(tp.getAttribute('data-bw-tier')||tp.dataset.t||0,10)); });

      if(units===0){
        if(nudge) { nudge.textContent=''; nudge.classList.remove('max'); }
      } else if(units<4){
        var need=(units<2?2:units<3?3:4); var pct=(need===2?5:need===3?8:10);
        var diff = need - units;
        if(nudge){
          if(loc==='sr'){
            nudge.textContent='Dodajte još '+diff+' '+(diff===1?'komad':'komada')+' → '+pct+'% popusta';
          } else if(loc==='de'){
            nudge.textContent='Noch '+diff+' '+(diff===1?'Teil':'Teile')+' hinzufügen → '+pct+'% Rabatt';
          } else {
            nudge.textContent='Add '+diff+' more → '+pct+'% off';
          }
          nudge.classList.remove('max');
        }
      } else {
        if(nudge){
          if(loc==='sr') nudge.textContent='✦ Maksimalan popust otključan — 10% popusta';
          else if(loc==='de') nudge.textContent='✦ Maximaler Rabatt freigeschaltet — 10% Rabatt';
          else nudge.textContent='✦ Max saving unlocked — 10% off';
          nudge.classList.add('max');
        }
      }

      if(addBtn && addBtn.dataset.busy!=='1'){
        if(!lookItems.length){
          addBtn.disabled=true;
          addBtn.textContent = i18n.selectStart || 'Select pieces to start';
        } else {
          addBtn.disabled=false;
          addBtn.textContent = (i18n.checkout || 'Continue to checkout')+' · '+fmtMoney(root, total);
        }
      }
      if(added && !lookItems.length) added.style.display='none';
    }

    // main button -> push staged look to the cart, then jump to checkout
    if(addBtn){
      addBtn.addEventListener('click', function(){
        if(addBtn.dataset.busy==='1') return;
        if(!lookItems.length) return;
        var lines=lookItems.map(function(it){ return { id: it.variantId, quantity: it.qty }; });
        addBtn.disabled=true; addBtn.dataset.busy='1';
        var prev=addBtn.textContent;
        addBtn.textContent = i18n.preparing || 'Preparing…';
        fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root+'cart/add.js' : '/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: lines })
        }).then(function(res){
          return res.json().then(function(json){
            if(!res.ok) throw new Error((json && json.description) || 'cart add failed');
            return json;
          });
        }).then(function(){
          window.location.href='/checkout';
        }).catch(function(){
          delete addBtn.dataset.busy;
          addBtn.disabled=false;
          addBtn.textContent=prev;
          if(added){
            added.style.display='block';
            added.textContent = i18n.checkoutError || 'Could not add to cart. Please try again.';
          }
        });
      });
    }

    render();
  }

  function initAll(){
    document.querySelectorAll('[data-bw-look-builder]').forEach(init);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function(e){
    var r=e.target.querySelector('[data-bw-look-builder]') || (e.target.matches('[data-bw-look-builder]') ? e.target : null);
    if(r) init(r);
  });
})();
